import React from 'react';
// import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import FilterBar from './FilterBar';

const uri = '/service/v1/collaborators';
const initialParams = {
  sort: 'az',
};

const useStyles = makeStyles(theme => ({
  avatar: {
    border: '1px solid #0000003b',
    height: 64,
    width: 64,
  },
  label: {
    padding: theme.spacing(0.25, 1),
    borderRadius: 4,
  },
  successLabel: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main,
  },
  errorLabel: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
  },
}));

function Collaborator() {
  // const classes = useStyles();
  const [params, setParams] = React.useState(initialParams);

  function handleFilter(parms) {
    setParams({ ...initialParams, ...parms });
  }

  // const AvatarComponent = (attr, row) => (
  //   <Avatar classes={{ root: classes.avatar }} src={attr} alt={row.full_name} />
  // );

  const tableHeaders = [
    {
      name: 'id_collaborator',
      label: 'ID',
      width: 100,
    },
    {
      name: 'names',
      label: 'Nombres',
    },
    {
      name: 'last_name',
      label: 'Apellidos',
    },
    { name: 'document_type', label: 'Tipo documento' },
    { name: 'document_number', label: 'Nro. documento' },
    { name: 'email', label: 'Email corporativo' },
  ];

  return (
    <>
      <Title variant="h5" component="h2">Colaborador</Title>
      <DataTable
        uri={uri}
        params={params}
        headers={tableHeaders}
        filters={<FilterBar onFilter={handleFilter} />}
      />
    </>
  );
}

export default Collaborator;
